/**
 * Return an object built from parameters in the location search string.
 *
 * @returns {Object}
 */
function decodeSearchString() {
  // Remove the leading "?" from the search string
  var query = window.location.search.slice(1);

  return query.split("&").reduce(function (obj, param) {
    // Guard against trailing "&" in the search string
    if (param === "") return obj;

    var pair = param.split("=");

    if (pair.length === 1) {
      // This is a boolean parameter with no value
      obj[pair[0]] = true;
    } else {
      obj[pair[0]] = decodeURIComponent(pair[1]);
    }

    return obj;
  }, {});
}

/**
 * Return a URL-encoded search string from `params`.
 *
 * @param {Object} params mapping of key-value pairs that are converted into a
 *   URL-encoded search string for the URL
 *
 * @returns {string} the URL-encoded search string built from the keys and
 *   values in `params`
 */
function encodeSearchString(params) {
  var searchString = Object.keys(params || {})
    .map(function (key) {
      if (params[key] === true) return key;
      // Strip out any unset parameters: false, 0, "", etc.
      if (!params[key]) return "";
      return key + "=" + encodeURIComponent(params[key]);
    })
    .filter(Boolean)  // Exclude empty strings
    .join("&");

  if (searchString.length < 1) return "";

  return "?" + searchString;
}

module.exports = {
  decodeSearchString: decodeSearchString,
  encodeSearchString: encodeSearchString,
};
